//这JS用来保存数据
export default {
	setInitData,
	getInitData,
	isShowQRimg,
	passwordedWatch,
	verifyCode,
	fans_id,
	header,
	identifierNick,
	userSig,
	real_auth,
	status,
	loginCode,
	setUserData,
	getUserData
}

var loginCode = "";


var fans_id = 0;
var header = "";
var identifierNick = "";
var userSig = "";
var real_auth = "";
var status = "";


//二维码是否显示了一次
var isShowQRimg = false;
//是否已经输入过密码
var passwordedWatch = false;

var verifyCode = '';

function setInitData(data){
	sessionStorage.setItem('initData', JSON.stringify(data));
}
function getInitData(){
	var initData = JSON.parse(sessionStorage.getItem('initData'));
	if(initData == null){
		return false;
	}else{
		return initData;
	}
}
function setUserData(data){
	sessionStorage.setItem('userData', JSON.stringify(data));
}
function getUserData(){
	var userData = JSON.parse(sessionStorage.getItem('userData'));
	if(userData == null){
		return false;
	}else{
		return userData;
	}
}

